import { useEffect, useState } from "react";
import styled from "styled-components";
import { Badge, Col, Modal, Row } from "react-bootstrap";

import { FileCard } from "common/components/organisms/files/FileCard";
import { RegisteredFileInfo } from "common/types/files/RegisteredFileInfo";
import DraggableModal from "common/components/molecules/DraggableModal";
import { ModalButtons } from "common/components/molecules/ModalButtons";

type Props = {
  show: boolean;
  candidates: { title: string; pictures: RegisteredFileInfo[] }[];
  selecteds: RegisteredFileInfo[];
  onOK: (value: RegisteredFileInfo[]) => void;
  onCancel: () => void;
};
export const SelectPictureDlg = (props: Props) => {
  const { show, candidates, selecteds } = props;

  const [selectedPictures, setSelectedPictures] = useState<RegisteredFileInfo[]>([]);

  const onClick = (file: RegisteredFileInfo) => {
    if (selectedPictures.find((x) => x.fileId === file.fileId)) {
      setSelectedPictures(selectedPictures.filter((x) => x.fileId !== file.fileId));
    } else setSelectedPictures([...selectedPictures, file]);
  };

  useEffect(() => {
    setSelectedPictures([...selecteds]);
  }, [selecteds]);

  return (
    <Modal show={show} dialogAs={DraggableModal}>
      <Modal.Header className="handle">
        <Modal.Title> 報告写真の選択</Modal.Title>{" "}
      </Modal.Header>
      <Modal.Body>
        <span className="notes">※保存済の写真のみ表示されます</span>
        <SlistDiv>
          {candidates.map((detail) =>
            detail.pictures.length === 0 ? (
              <></>
            ) : (
              <>
                <span className="h6 mt-2">{detail.title}</span>
                <Row>
                  {detail.pictures.map((file) => (
                    <Col sm={6} className="my-1">
                      <SClickDiv key={`pick_${file.fileId}`} onClick={() => onClick(file)}>
                        <FileCard
                          file={file}
                          imgHeight="7rem"
                          cardWidth="13rem"
                          showPicture={true}
                          canDownload={false}
                          readOnly={true}
                        />
                        {selectedPictures.find((x) => x.fileId === file.fileId) && (
                          <SBadge bg={"transparent"}>
                            <i className="fas fa-circle-check" />
                          </SBadge>
                        )}
                      </SClickDiv>
                    </Col>
                  ))}
                </Row>
              </>
            )
          )}
        </SlistDiv>
      </Modal.Body>
      <Modal.Footer>
        <ModalButtons
          onOk={() => {
            props.onOK(selectedPictures);
          }}
          okText="決定"
          onCancel={props.onCancel}
        />
      </Modal.Footer>
    </Modal>
  );
};

const SlistDiv = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px;
  margin: 0;
`;

const SClickDiv = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  justify-self: flex-start;
  &.selected {
  }
`;

const SBadge = styled(Badge)`
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  color: #00bb00;
  font-size: 18px;
`;
